<ion-item-group>
  <ion-item-divider>
    <ion-label translate>Mobile.GenericSettings</ion-label>
  </ion-item-divider>

  <ion-item>
    <ion-toggle [checked]="darkMode" (ionChange)="onDarkModeChange($event)">
      {{ 'Mobile.DarkModeEnabled' | translate }}
    </ion-toggle>
  </ion-item>

  <ion-item>
    <ion-toggle [checked]="largeFontEnabled" (ionChange)="onLargeFontEnabledChange($event)">
      {{ 'Mobile.LargeFontEnabled' | translate }}
    </ion-toggle>
  </ion-item>

  <ion-item lines="none">
    <ion-toggle [checked]="largeMenuEnabled" (ionChange)="onLargeMenuEnabledChange($event)">
      {{ 'Mobile.LargeMenuEnabled' | translate }}
    </ion-toggle>
  </ion-item>
</ion-item-group>
